import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { EmployeeService } from '../../services/employees.service';
import { CRMService } from '../../services/crm.service';
import { Employee } from '../../models/models';

@Component({
    selector: 'crm-dashboard',
    templateUrl: './crm-dashboard.component.html',
    standalone: false
})
export class CrmDashboard implements OnInit {

    public employees: Employee[] = [];
    public repTypes: string[] = ['All', 'AccountRep', 'OpsRep', 'SalesRep'];
    public selectedEmployeeID: number = -1;
    public selectedRepType: string = 'All';
    public blankEmployee: Employee = { employeeId: -1, fullName: 'All' } as Employee;
    private selectedTab: string = "Home";

    constructor(private crmService: CRMService, private employeeService: EmployeeService, private router: Router, private activatedRoute: ActivatedRoute,
        private titleService: Title) {
        titleService.setTitle('CRM Dashboard');
    }

    ngOnInit() {
        this.setFilters();
        this.getEmployees();
    }

    setFilters() {
        var currentRoute = this.router.url.split('/');

        if (currentRoute.length > 3) {
            this.selectedRepType = currentRoute[3];
            this.selectedEmployeeID = parseInt(currentRoute[4]);
        } else {
            this.selectedRepType = 'All';
            this.selectedEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }

        this.filterChanged();
    }

    getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employees = result;
        });
    }

    onActivate(componentRef) {
        this.crmService.accounts = [];
        this.crmService.leads = [];
        this.crmService.followUps = [];
        this.crmService.prospects = [];
        this.crmService.opportunities = [];
        //console.log(componentRef);
    }

    filterChanged() {
        if (!this.selectedRepType) return;

        //if (this.selectedTab != "Accounts" && this.selectedTab != "Leads") {
        //    var currentRoute = this.router.url.split('/')[2];
        //    this.router.navigate(['crm-dashboard/' + currentRoute, this.selectedRepType, this.selectedEmployeeID]);
        //}
        var currentRoute = this.router.url.split('/')[2];
        this.router.navigate(['crm-dashboard/' + currentRoute, this.selectedRepType, this.selectedEmployeeID]);
    }

    public onTabSelect(evt: any) {
        console.log("onTabSelect", evt);
        var tabName: string = evt.title;
        this.selectedTab = tabName;
        if (tabName == "Home") {
            this.router.navigate(['crm-dashboard/crm-home', this.selectedRepType, this.selectedEmployeeID]);
        }
        else if (tabName == "Accounts") {
            this.router.navigate(['crm-dashboard/crm-accounts', this.selectedRepType, this.selectedEmployeeID]);
        }
        else if (tabName == "Leads") {
            this.router.navigate(['crm-dashboard/crm-leads', this.selectedRepType, this.selectedEmployeeID]);
        }
        else if (tabName == "Prospects") {
            this.router.navigate(['crm-dashboard/crm-prospects', this.selectedRepType, this.selectedEmployeeID]);
        }
        else if (tabName == "Opportunities") {
            this.router.navigate(['crm-dashboard/crm-opportunities', this.selectedRepType, this.selectedEmployeeID]);
        }
        else if (tabName == "Follow Ups") {
            this.router.navigate(['crm-dashboard/crm-follow-ups', this.selectedRepType, this.selectedEmployeeID]);
        }
        else if (tabName == "Customer Actions") {
            this.router.navigate(['crm-dashboard/crm-customer-actions', this.selectedRepType, this.selectedEmployeeID]);
        }
        else {
            this.router.navigate(['crm-dashboard/crm-home', this.selectedRepType, this.selectedEmployeeID]);
        }
    }

    public isLinkActive(name: string): boolean {
        //console.log(this.router.url + ' - ' + name);
        var url = this.router.url;
        return this.router.url.includes(name);
    }
}